
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Sc from 'vux/src/components/scroller/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'


const refreshKey = ['A', 'B01', 'B02', 'B03', 'B04', 'B05', 'B06', 'B07', 'B08', 'B09', 'B010'];
let refreshKeyIndex = 0;
let page =0;
let prepage = 10;
let firstLoaded = false;
let moreLoaded = true;
function getRefreshKey() {
refreshKeyIndex++;
if (refreshKeyIndex >= refreshKey.length) {
refreshKeyIndex = 0;
}
return refreshKey[refreshKeyIndex];
}

export default {
name: 'app',
components:{
ViewBox,
XHeader,
Tabbar,
TabbarItem,
Sc,
Tab,
TabItem
},
mounted() {
this.$store.dispatch('getTopList').then(() => {

firstLoaded = true;
});
},
computed: {
categories(){
return this.$store.getters.categories;
},
categoryKey(){
return this.$store.getters.categoryKey;
}
},
methods: {
refresh() {
this.$store.dispatch('refreshNewList', {
refreshKey: getRefreshKey()
}).then(n => {
this.$refs.myScroller.finishPullToRefresh();
this.$vux.toast.text(`成功为您推荐${n}条新内容`, top);
});
},
infinite() {

if(!firstLoaded){
this.$refs.myScroller.finishInfinite();
return;
}

if(!moreLoaded){
return;
}
moreLoaded = false;
page++;
this.$store.dispatch('loadMoreList',{
refreshKey:refreshKey[refreshKeyIndex],
page,
prepage
}).then( () => {
this.$refs.myScroller.finishInfinite();
moreLoaded = true;
} )

}

}
}



// WEBPACK FOOTER //
// ./src/App.vue